// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCountryFromCode } from '../../utils/utils';
import {
  getCurrentCountry,
  getCurrentOffice,
  getCurrentShoppingCenter,
} from '../../utils/urlUtils';
import type { ReconciliationStore, ShoppingCenter } from '../../types/shoppingCenterType';
import type { OfficePartial } from '../../types/OfficesType';
import { WORLD_MAP } from '../../path/worldPaths';
import { AREA_MAP } from '../../path/areaPath';
import { OFFICE_INFO } from '../../path/officePath';
import { MALL_INFO } from '../../path/mallPath';
import { STORE_INFO } from '../../path/storePath';

type Props = {
  baseShoppingCenterList: ShoppingCenter[],
  baseOfficeList: OfficePartial[],
  location: Location,
  isOfficeSelected: boolean,
  selectedStore: ReconciliationStore,
  currentDivisionIndex: number,
  moveUp: string => void,
}

function HeaderBreadCrumb({
  baseShoppingCenterList,
  baseOfficeList,
  location,
  isOfficeSelected,
  selectedStore,
  currentDivisionIndex,
  moveUp,
}: Props) {
  const officeOrSc = isOfficeSelected
    ? getCurrentOffice(location.search, baseOfficeList)
    : getCurrentShoppingCenter(location.search, baseShoppingCenterList);

  const area = officeOrSc
    ? getCountryFromCode(officeOrSc.countryCode)
    : getCurrentCountry(location.search);

  const defaultTextOfficeOrMall = isOfficeSelected
    ? <Translate value="header.OFFICE" />
    : <Translate value="header.STORE" />;

  return (
    <div className="title header-bread-crumb">
      <button
        className="crumb-container"
        onClick={() => moveUp(WORLD_MAP)}
      >
        <Translate value="header.HOME" />
      </button>
      {
        currentDivisionIndex > 0 && (
          <React.Fragment>
            <i className="fas fa-chevron-right crumb-separator" />
            <button
              className="crumb-container"
              onClick={() => moveUp(`${AREA_MAP}?area=${area.id}`)}
            >
              {
                area
                  ? area.label
                  : <Translate value="header.AREA" />
              }
            </button>
          </React.Fragment>
        )
      }
      {
        currentDivisionIndex > 1 && (
          <React.Fragment>
            <i className="fas fa-chevron-right crumb-separator" />
            <button
              className="crumb-container"
              onClick={() => {
                const url = isOfficeSelected
                  ? `${OFFICE_INFO}?office=${officeOrSc.id}`
                  : `${MALL_INFO}?mall=${officeOrSc.id}`;
                moveUp(url);
              }}
            >
              {
                officeOrSc
                  ? officeOrSc.name.toUpperCase()
                  : defaultTextOfficeOrMall
              }
            </button>
          </React.Fragment>
        )
      }
      {
        currentDivisionIndex > 2
        && (
          <React.Fragment>
            <i className="fas fa-chevron-right crumb-separator" />
            <button
              className="crumb-container"
              onClick={() => moveUp(`${STORE_INFO}?store=${selectedStore.id}&mall=${officeOrSc.id}`)}
            >
              {
                (selectedStore && officeOrSc)
                  ? <span>{selectedStore.retailerName}</span>
                  : <Translate value="header.STORE" />
              }
            </button>
          </React.Fragment>
        )
      }
    </div>
  );
}

export default withRouter(connect(state => ({
  shoppingCenterList: state.shoppingCenterFilters.filteredShoppingCenterList,
  baseShoppingCenterList: state.shoppingCenterFilters.baseShoppingCenterList,
  baseOfficeList: state.office.baseOfficeList,
  isOfficeSelected: state.office.isOfficeSelected,
  selectedStore: state.store.selectedStore,
}))(HeaderBreadCrumb));
